import { createLikeableSchema, LikeableEntity } from 'mk2/containers/Like/Like.schemas';
import { Entity, PhotoEntity, PhotoSchema, UserEntity, UserSchema } from 'mk2/schemas';
import { schema } from 'normalizr';

export interface WikiCategoryEntity extends Entity {
    id: number;
    name: string;
    slug: string;
    categoryArticleId: number;
    categoryArticleSlug: string;
}

export interface ExperienceEntity extends Entity {
    id: number;
    text: string;
    title: string;
    created: string;
    authorUser: UserEntity;
    likeable: LikeableEntity;
    positives: string[];
    negatives: string[];
    starsCount: number;
    article: ArticleEntity;
}

export interface AST {
    type: string;
    elements?: AST[];
    text?: string;
    obj_type?: string;
    obj_id?: number;
}

export interface ArticleEntity extends Entity {
    id: number;
    author: UserEntity;
    createdAt: string;
    modifiedAt: string;
    deletedAt: string;
    title: string;
    instrumentalTitle: string;
    photos: PhotoEntity[];
    text: string;
    bodyAST: AST;
    countExperiences: {[articleUrl: string]: number};
    countTopicContributors: {[topicSlug: string]: number};
    categorySlugs: {[articleUrl: string]: string};
    linkedObjects: {[objType: string]: {[objId: number]: {url: string}}};
    experiencesAllowed: boolean;
    experiencesStarsAllowed: boolean;
    experiencesPositivesNegativesAllowed: boolean;
    slug: string;
    likeable: LikeableEntity;
    experiences: ExperienceEntity[];
    category: WikiCategoryEntity;
    disabledAds: boolean;
    seoTitle: string; // text co ide do <title>...</title> a google zobrazuje v SERP
    seoDescription: string; // text co ide <meta name="description" content="..."> a google zobrazuje v SERP
}

export const WikiCategorySchema = new schema.Entity('wikiCategories');

export const ExperienceSchema = new schema.Entity('experience', {
    authorUser: UserSchema,
    likeable: createLikeableSchema('wiki-experience'),
});

export const ArticleSchema = new schema.Entity('wikiArticles', {
    author: UserSchema,
    photos: [PhotoSchema],
    experiences: [ExperienceSchema],
    category: WikiCategorySchema,
    likeable: createLikeableSchema('wiki-article'),
});

ExperienceSchema.define({ article: ArticleSchema });
